module.exports = __webpack_public_path__ + "img/img1.23e0e650.jpg";